import { Component, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { filter, map, takeWhile } from 'rxjs/operators';
import * as fromSettings from '../../company-setting';
import { CompanySetting } from '../../company-setting';
import * as fromDataServices from '../../data-services';
import { LoadGroups } from '../../groups';
import { IGroup } from '../../groups/IGroups';
import * as fromGroups from '../../groups/store/reducer';
import * as fromCommon from '../../shared';
import * as fromShared from '../../shared';
import { SelectItem } from '../../shared';
import * as fromUser from '../../user-info';
@Component({
    selector: 'ef-pto-policy-feature',
    templateUrl: './pto-policy-feature.component.html',
    styleUrls: ['./pto-policy-feature.component.scss'],
    standalone: false
})
export class PtoPolicyFeatureComponent implements OnInit {
    active = true;

    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromCommon.IStatusMessage>;
    ShowError = new ReplaySubject<fromShared.Errors.IShowErrors>(1);

    process$: Observable<fromShared.Process>;
    public policySetup$: Observable<
        fromDataServices.PolicySetup.PtoPolicySetup[]
    >;
    public policySetup: fromDataServices.PolicySetup.PtoPolicySetup[];
    public policyAssignment$: Observable<
        fromDataServices.PolicyAssignment.PtoPolicyAssignment[]
    >;
    public accrualPeriods$: Observable<
        fromDataServices.AccrualPeriod.AccrualPeriodModel[]
    >;

    public groups$: Observable<Array<IGroup>>;

    public userInfo$: Observable<fromUser.IUserInfo>;

    isQBO$: Observable<boolean>;

    public companySettings$: Observable<Array<CompanySetting>>;
    public accrualsFilterSelectItem: SelectItem[];

    policySetupDataService: EntityCollectionService<fromDataServices.PolicySetup.PtoPolicySetup>;
    policyAssignmentDataService: EntityCollectionService<fromDataServices.PolicyAssignment.PtoPolicyAssignment>;
    accrualPeriodDataService: EntityCollectionService<fromDataServices.AccrualPeriod.AccrualPeriodModel>;
    constructor(
        public entityServices: EntityServices,
        private log: fromShared.Services.Logging.LoggingService,
        private store: Store
    ) {
        this.policySetupDataService =
            entityServices.getEntityCollectionService<fromDataServices.PolicySetup.PtoPolicySetup>(
                fromDataServices.PolicySetup.entityName
            );
        this.policyAssignmentDataService =
            entityServices.getEntityCollectionService<fromDataServices.PolicyAssignment.PtoPolicyAssignment>(
                fromDataServices.PolicyAssignment.entityName
            );
        this.accrualPeriodDataService =
            entityServices.getEntityCollectionService<fromDataServices.AccrualPeriod.AccrualPeriodModel>(
                fromDataServices.AccrualPeriod.entityName
            );
    }

    ngOnInit(): void {

        this.store.dispatch(
            fromSettings.getCompanySetting({ SettingType: 'QBUpdateAccrual' })
        );
        this.policySetupDataService.getAll();
        this.policyAssignmentDataService.getAll();
        this.accrualPeriodDataService.getAll();
        this.store.dispatch(
            new LoadGroups({
                Categoryid: 'PUBLIC000000000000000000000000000000'
            })
        );
        this.setupObservables();
        this.setupSubscriptions();
    }

    ngOnDestroy() {
        this.active = false;
        this.policySetupDataService.clearCache();
        this.policyAssignmentDataService.clearCache();
    }

    setupObservables() {
        this.isQBO$ = this.store.pipe(select(fromSettings.isQBOEnabled));

        this.companySettings$ = this.store.pipe(select(fromSettings.selectAll));

        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        this.groups$ = this.store.pipe(select(fromGroups.getGroups));

        this.accrualPeriods$ = this.accrualPeriodDataService.entities$.pipe(
            map(x => clone(x))
        );

        this.policySetup$ = this.policySetupDataService.entities$.pipe(
            filter(items => !!items && items.length > 0),
            map(x => clone(x))
        );
        this.policyAssignment$ =
            this.policyAssignmentDataService.entities$.pipe(map(x => clone(x)));

        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
    }

    setupSubscriptions() {
        combineLatest([this.process$, this.ShowError])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });

        combineLatest([this.policySetup$, this.accrualPeriods$])
            .pipe(takeWhile(() => this.active))
            .subscribe(([policySetup, accrualPeriods]) => {
                if (policySetup && accrualPeriods) {
                    if (policySetup.length > 0 && accrualPeriods.length > 0) {
                        policySetup.forEach(x => {
                            const period = accrualPeriods.find(
                                y => y.AccrueLeavePeriodID == x.AccrualPeriodID
                            );
                            x.AccrualPeriod = period.AccrueLeavePeriod;
                        });
                        // policySetup = policySetup.map(p => ({
                        //     ...p,
                        //     AccrualPeriod: this.findAccrualPeriod(p, accrualPeriods)
                        // }));
                        this.policySetup = policySetup;
                        this.accrualsFilterSelectItem = policySetup.map(x => ({
                            value: x.AccrualPeriod,
                            label: x.AccrualPeriod
                        }));
                        this.accrualsFilterSelectItem =
                            this.accrualsFilterSelectItem.filter(
                                (v, i, a) =>
                                    a.findIndex(t => t.label === v.label) === i
                            );
                    }
                }
            });
    }

    onSavePolicySetup($event) {
        this.policySetupDataService.upsert($event);
        this.policyAssignmentDataService.getAll();
    }
    onDeletePolicySetup($event) {
        this.policySetupDataService.delete($event);
        this.policyAssignmentDataService.getAll();
    }
    onSavePolicyAssignment($event) {
        this.policyAssignmentDataService.upsert($event);
    }
    onUpdateCompanySetting($event) {
        this.store.dispatch(
            fromSettings.putCompanySettings({
                settings: [
                    {
                        SettingType: 'QBUpdateAccrual',
                        SettingValue: $event == true ? '1' : '0'
                    }
                ]
            })
        );
    }

    findAccrualPeriod(rowData, accrualPeriods) {
        let accrualPeriod;
        if (accrualPeriods.length > 0) {
            accrualPeriod = accrualPeriods.find(
                x => x.AccrueLeavePeriodID == rowData.AccrualPeriodID
            ).AccrueLeavePeriod;
            return accrualPeriod;
        }
    }
}
